const state = {
  history: null,
  searchbarVisible: null,
};

const getters = {
  history: state => {
    let searches;
    if (state.history) {
      return state.history;
    } else if (searches = JSON.parse(localStorage.getItem('searches'))) {
      return searches;
    } else {
      return [];
    }
  },
  visible: state => state.searchbarVisible,
};

const mutations = {
  clearSearch(state) {
    localStorage.removeItem('searches');
    state.history = null;
  },
  recordSearch(state, query) {
    if (query) {
      let searches = localStorage.getItem('searches');
      searches = searches ? JSON.parse(searches) : [];
      searches.unshift(query);
      if (searches.length > 5) {
        searches.pop();
      }
      localStorage.setItem('searches', JSON.stringify(searches));
      state.history = searches;
    }
  },
  setSearchbarVisibility(state, val) {
    state.searchbarVisible = val;
  },
};

const actions = {
  search({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].get('/searches', { params }).then(response => {
      return response.data;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
